import {Injectable} from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DashboardComponent } from '../dashboard.component';

export interface CanDeactivateComponent {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate <CanDeactivateComponent> {
  canDeactivate( component: CanDeactivateComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot): boolean {
    // if (component.unsavedChanges) {
      // return confirm('Are you sure?');
    // }
    // console.log(state);
    // console.log(route);
      
     return true;
     // return component.canDeactivate ? component.canDeactivate() : true;
    // return window.confirm('Discard changes?');
    
  }
}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/guards/can-deactivate-guard.ts